import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-clm-heating-performance-input',
    imports: [
    MatIcon,
    ReactiveFormsModule,
    FormsModule
],
    templateUrl: './clm-heating-performance-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-heating-performance-input.component.css'
})
export class ClmHeatingPerformanceInputComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  airflowSelection!: GuruEntity;
  edbSelection!: GuruEntity;
  eftSelection!: GuruEntity;
  totalCapacitySelection!: GuruEntity;
  loadEftSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.HEATING_PERFORMANCE_INPUTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.airflowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHFAirflow');
    this.edbSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHEDB');
    this.eftSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHEWT');
    this.totalCapacitySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHWTot');
    this.loadEftSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHLEWT');
  }

  textSelectionChanged(entity: GuruEntity): void {
    this.selectionChanged(entity, entity.Value);
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
